import { useMemo } from 'react';
import type {
  DoseSpotClinicianInfoT,
  EmployeeRecordT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { useZodForm } from '@/shared/lib/forms';

import type { PrescriberDetailsFormValues } from './types';
import { prescriberDetailsFormSchema } from './prescriber-details-schema';
import { prescriberDefaultsFromEmployeeRecord } from './employee-record-prefill';
import { clinicianInfoFromDoseSpot } from './prescriber-details-model';
import { createQaPrescriberInfoDefault, isQaFixtureActive } from './qa-dosespot-fixtures';

export interface UsePrescriberDetailsFormOptions {
  prefill?: DoseSpotClinicianInfoT | null;
  employeeRecord?: EmployeeRecordT | null;
}

export function usePrescriberDetailsForm(options: UsePrescriberDetailsFormOptions = {}) {
  const { prefill, employeeRecord } = options;

  const defaultValues = useMemo<PrescriberDetailsFormValues>(() => {
    if (isQaFixtureActive()) {
      return { clinicianInfo: createQaPrescriberInfoDefault() };
    }
    if (prefill) {
      return { clinicianInfo: clinicianInfoFromDoseSpot(prefill) };
    }
    if (employeeRecord) {
      return { clinicianInfo: prescriberDefaultsFromEmployeeRecord(employeeRecord) };
    }
    return { clinicianInfo: createQaPrescriberInfoDefault() };
  }, [prefill, employeeRecord]);

  const { form, validateDraft } = useZodForm<PrescriberDetailsFormValues>({
    schema: prescriberDetailsFormSchema,
    defaultValues,
    resetOnDefaultsChange: true,
  });

  return { form, validateDraft };
}
